import { getCategoriesAndExperiences } from 'services/apis/filter-section-api';
import { GET_FILTER_SECTION } from 'constants/filter-section';

export const getFiltersAction = () => ({
  type: GET_FILTER_SECTION,
  payload: getCategoriesAndExperiences(),
});
